var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0_19_208)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_19_208",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_19_208",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_19_208",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAAAXNSR0IArs4c6QAABDVJREFUeF7tnT2PTkEUx8+ZeQoioVegEuulIYLY/QpUNkgIoZGodPQSlZLKKliS1YjPsAQJhZes6Ch8AIms4pk53HU31trdzJl7n9mZnf9WW5w7L//f+c/ce8/zPMOEv6wU4KxGg8EQgGSWBAACIJkpkNlw4BAAyUyBzIYDhwBIZgpkNhw4BEAyUyCz4cAhAJKZApkNpxeHiMhe7/1JItrNzFsym+NIhyMiP4joszHmKTPPde2sExAR2ea9v0tEp4mqfy8mRPTYGHOFmb/HgokG0sKYJaL9sZ1v0OveG2PGY6FEA3HOPSKiMxtU1K7TemitPRfTSBSQds/4gGVqVcnFGLMvZk+JAuKcu0FEN2MyoKJrrltrb2nnGwvkPhFd0HZWWfyUtfaSds5RQLz3MyJySttZTfHM/MQYM6mdM4BoFQuMB5BAoVKFAUgqpQP7AZBAoVKFAUgqpQP7qRnIvIi8bXRi5oNEtDlQs5GGVQlERF5ZayeZ+WujrojscM7NMPORkaod0HiNQOaNMXsWYSxqJCI7vfefiGhTgG4jC6kOiIjMDgaDiZUUHQ6Hs8x8fGRqBzRcHZC1JpzDmwQAWZK1ABJg4b5D4JCCMhAO6Tv9A9qDQ+CQgDT5G4JNvaCEWYtssfUQLFkFZSA2ddXq2k8wHAKHqDIJm3pBCYNNXZXb/QTDIXDI+n4uC5t6QRmI217dsrtQAzfGfNNd9m+0iLy01t5eqQ3n3DVmPtqlfe/99i41+iL2kOU18C6Cpbi2S42+BCAr1sBTCNulj9gaffZA1qqBdxEsxbUxNfoSgDwfDAbjKQTsu4/hcPiCmY9p2s0eCBE1S9YYM3/RTGy9Y0Vkl/e++Xat6mNFJQBpPsj2uv1gWxFQmv3DOfeEmQ9rE6MIIO2kforIm0Juew9pnbEIriQg2mRbMR5P6nhSVyUSHFJQwuD1uyq3+wmGQ+AQvH5fc+mp7WvRuMsqaElAPaSffVDVChwCh/SWMLjtVUnZTzBuewtyMBzST9KrWoFD4BA8GOLBcIkCuO3NbEkQkVVr9DE1cNUGERBc3R6yWo0+tgYeoLEqpEYg/9Xou9TAVWoHBFcJpNVloUbf/M/M0TXwAI1VITUDUQmVKhhAUikd2A+ABAqVKgxAUikd2A+ABAqVKgxAUikd2E9SIM65KSK6GDi2WsPuWWsvaycf9VsnOK4iSOZ0x1WIyJj3/iMOdFkVjG8PdGl+HVX1F+WQpgfn3PTv08nOqnqrJ/iBtfZ8zHSjgYjIVu99cyjYgZiON/A174wxE8kPBWsEbaHcaZ0SDXeDwPFENG2MuRoLY+F9XB9itHvKCSJqfmm6xoMl54wxz5hZvWcs178XIH1ARRt/FACQzDIBQAAkMwUyGw4cAiCZKZDZcOAQAMlMgcyGA4cASGYKZDYcOARAMlMgs+HAIZkB+QW34vCSMvjeXAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSum);
export default __webpack_public_path__ + "static/media/Sum.d3893b0afa62a14e39b577791ae2f5ef.svg";
export { ForwardRef as ReactComponent };